import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router';
import moment from 'moment/moment';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { szltStatusFormatter } from '../../../utils/formatters';
import { getRegisterData } from '../reducer';
import SZLTViewData from './SZLTViewData';
import Loader from '../../../components/base/Loader/Loader';
import CarrierMiniGrid from './CarrierMiniGrid';
import VehiclesMiniGrid from './VehiclesMiniGrid';
import DocumentList from '../../Application/components/DocumentList';
import { RegistryRelationHistoryDialog } from './RegistryRelationHistoryDialog';
import RegistryPageModal from './RegistryPageModal';
import ApplicationLegend from '../../Application/components/ApplicationLegend';
import {
  APPLICATION_STATUS, REGION_REGISTRY_RELATION,
} from '../../../configs';
import AccordionWithPreview from '../../../components/base/Accordion/AccordionWithPreview';

export default function SZLTView(props) {
  const {
    onClose = () => {},
    loadData = () => {},
    formMeta,
  } = props;
  const [isHistoryPopUp, setIsHistoryPopUp] = useState(false);
  const [isSameRegistryPopUp, setIsSameRegistryPopUp] = useState(false);
  const {
    currentSZLT = {},
    loadingCheckAllSzlt,
  } = useSelector(getRegisterData);

  return ReactDOM.createPortal(
    <div className="application-form">
      <Loader loading={loadingCheckAllSzlt} />
      <div className="application-form-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev">Реестры</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-prev">Реестр СЗЛТ</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-prev">Карточка реестра СЗЛТ</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span
            className="breadcrumbs-current"
          >Карточка реестра СЗЛТ № {currentSZLT?.number || 'Без номера'} (просмотр)
          </span>
        </div>
        <div className="legend-button">
          <Icons width={24} height={24} customIcon icon="helper" />
          <ApplicationLegend />
        </div>
        <div className="close-button" onClick={onClose}>
          <Icons width={24} height={24} customIcon icon="close" />
        </div>
      </div>
      <div className="application-form-body application-form-view szlt-registry">
        <div className="application-form-body-wrapper">
          <div className="application-form-content">
            <div className="application-form-fields">
              <div className="application-form-fields-wrapper custom-scroll-theme">
                <div className="afc-header">
                  Запись СЗЛТ №{currentSZLT.number}
                  {szltStatusFormatter(currentSZLT.status)}
                  <div className="afc-header-link">
                    <div className="afc-header-link-same">
                      <Icons
                        customIcon
                        icon="same-registry"
                        onClick={() => setIsSameRegistryPopUp(true)}
                      />
                    </div>
                    <NavLink
                      to={{
                        pathname: '/application',
                        search: new URLSearchParams({
                          filter: 'carrier',
                          status: Object.values(APPLICATION_STATUS),
                          number: currentSZLT.number,
                          created_at: [moment(currentSZLT.created_at).subtract(1, 'year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
                        }).toString(),
                      }}
                      target="_blank"
                    >
                      <Icons
                        customIcon
                        icon="show-relation-link"
                      />
                    </NavLink>
                  </div>
                </div>
                <div className="afc-body">
                  <div className="afc-main">
                    <SZLTViewData currentSZLT={currentSZLT} formMeta={formMeta} />
                    <div className="hr-row" />
                    <AccordionWithPreview
                      title="Документы"
                      content={(
                        <DocumentList
                          id={currentSZLT?.id}
                          loadData={loadData}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="application-form-content afc-right">
            <VehiclesMiniGrid
              params={{
                order_service_id: currentSZLT.id,
              }}
              setIsHistoryPopUp={setIsHistoryPopUp}
              isCarrierRelationType={false}
            />
            <CarrierMiniGrid
              params={{
                order_service_id: currentSZLT.id,
              }}
              setIsHistoryPopUp={setIsHistoryPopUp}
              isVehicleRelationType={false}
            />
          </div>
          {isHistoryPopUp ? (
            <RegistryRelationHistoryDialog
              currentCarrier={currentSZLT}
              subject_type="order_service"
              subject_id={currentSZLT?.id}
              log_name={isHistoryPopUp === 'vehicle' ? REGION_REGISTRY_RELATION.CARRIER_VEHICLE : REGION_REGISTRY_RELATION.ORDER_SERVICE_CARRIER}
              onClose={() => setIsHistoryPopUp(false)}
            />
          ) : null}
          {isSameRegistryPopUp
            ? (
              <RegistryPageModal
                type="szlt"
                onClose={() => setIsSameRegistryPopUp(false)}
                customFilter={{
                  inn: currentSZLT?.inn,
                }}
                title="Реестровые записи в отношении данного СЗЛТ"
                filterName="szlt-same-list-modal-filter"
              />
            ) : null}
        </div>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
